import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { PHOTO_STAGE_TITLE } from "../constants";
import VehiclePhotoGallery from "../dashboard/components/VehiclePhotoGallery";
import ModalCard from "./ModalCard";
import Plate from "./Plate";

const useStyles = makeStyles({
  head: { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 },
});

/*
 * One stage's set, opened from the photos line in a booking's history. It sits
 * above the booking view rather than replacing it: the reason anyone opens a
 * set is to check it against what the rest of the modal says.
 */
export default function StagePhotosModal({ row, facilityId, stage, onClose }) {
  const s = useStyles();

  return (
    <ModalCard
      title={PHOTO_STAGE_TITLE[stage] ?? "Vehicle photos"}
      subtitle={row.guestName || "Unmatched plate"}
      onClose={onClose}
      width={560}
      z={1500}
    >
      <div className={s.head}>
        <Plate size={13}>{row.plate}</Plate>
        <span>{row.vehicle}</span>
      </div>

      <VehiclePhotoGallery
        bookingId={row.bookingId}
        facilityId={facilityId}
        stage={stage}
      />
    </ModalCard>
  );
}
